<template>
  <header>
    <b-navbar toggleable="lg" type="dark">
      <h1 class="header__title float-left" txt="长江网盘">长江网盘(内测)</h1>
      <p class="header__info float-left">
        <span class="separator">|</span>
        <span class="info">安全&nbsp;&nbsp;&nbsp;智能&nbsp;&nbsp;&nbsp;便捷&nbsp;&nbsp;&nbsp;可协同的网络文件存储和管理服务</span>
      </p>
    </b-navbar>
  </header>
</template>

<script>
  export default {
    name: "Header"
  }
</script>

<style lang="stylus" scoped>
  header
    padding-left: 55px
    height: 78px
    line-height: 78px
    color: #fff
    background-color: #2b3245

    .navbar
      align-items: stretch
      padding: 0

    .header__title
      position: relative
      margin-right: 26px
      line-height: 78px
      font-size: 30px
      color: #fff

      &:before
        content: attr(txt)
        position: absolute
        z-index: 10
        color: #cbd7f7
        -webkit-mask: linear-gradient(to bottom, #cbd7f7, transparent)


    .header__info
      font-size: 0

      .separator
        margin-right: 26px
        font-size: 16px

      .info
        font-size: 16px
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Header.vue